import React from "react";
import {
  Button,
  Carousel,
  CarouselAnnouncerFunction,
  CarouselButton,
  CarouselCard,
  CarouselSlider,
  Skeleton,
  SkeletonItem,
  Spinner,
} from "@fluentui/react-components";
import { useReplyCarouselStyles } from "./styles";
import { TextTRegular } from "@fluentui/react-icons";
import { insertTextAtCursor } from "@/taskpane/lib";
import log from "../../../../utils/logger";

const SUGGESTION_MARKER = "---SUGGESTION SEPARATOR---";
const DISCLAIMER_PART =
  "DISCLAIMER: This draft clause is for informational and drafting purposes only and should be reviewed by a qualified legal professional before use.";

interface IProps {
  queryReply: string;
  loading?: boolean;
  loadingInsertion?: boolean;
  setLoadingInsertion: React.Dispatch<React.SetStateAction<boolean>>;
}

const getAnnouncement: CarouselAnnouncerFunction = (index: number, totalSlides: number) => {
  return `Carousel slide ${index + 1} of ${totalSlides}`;
};

export default function ReplyCarousel({ queryReply, loading, loadingInsertion, setLoadingInsertion }: IProps) {
  const styles = useReplyCarouselStyles();

  const onInsertAtCursor = async (suggestion: string) => {
    try {
      setLoadingInsertion(true);
      await insertTextAtCursor(suggestion.replace(DISCLAIMER_PART, "").replace(/^[\r\n]+|[\r\n]+$/g, ""));
    } catch (error) {
      log.error("Insert text at cursor failed", "onInsertAtCursor", error);
    } finally {
      setLoadingInsertion(false);
    }
  };

  return (
    <Carousel groupSize={1} announcement={getAnnouncement} className={styles.carousel}>
      {loading ? (
        <Skeleton className={styles.skeleton}>
          {Array.from({ length: 10 }, (_v, i) => i).map((i) => (
            <SkeletonItem key={`skeleton-${i}`} />
          ))}
        </Skeleton>
      ) : (
        <>
          <div className={styles.carouselContent}>
            <CarouselButton navType="prev" aria-label="Previous Carousel Page Button" />

            <div className={styles.viewport}>
              <CarouselSlider>
                {queryReply.split(SUGGESTION_MARKER).map((suggestion, i) => (
                  <CarouselCard key={`suggestion-${i}`} className={styles.carouselCard}>
                    <p className={styles.suggestion}>{suggestion.replace(/^\n+/, "")}</p>
                    <Button
                      disabled={loadingInsertion}
                      onClick={() => onInsertAtCursor(suggestion.replace(/^\n+/, ""))}
                      icon={loadingInsertion ? <Spinner size="extra-tiny" /> : <TextTRegular />}
                      className={styles.insertTextBtn}
                    >
                      Insert at cursor
                    </Button>
                  </CarouselCard>
                ))}
              </CarouselSlider>
            </div>

            <CarouselButton navType="next" aria-label="Next Carousel Page Button" />
          </div>
        </>
      )}
    </Carousel>
  );
}
